import { FF_NEW_INDIA_WIZARD } from 'constants/features';
import { usePeertransferFlags } from 'hooks/usePeertransferFlags/usePeertransferFlags';
import { useSelector } from 'react-redux';
import { getRecipientId } from 'selectors';

const NEW_WIZARD_INDIA_ENABLED_FOR_RECIPIENTS = ['PTU', 'FWU'];

const useNewWizardIndiaEnabled = () => {
  const recipientId = useSelector(getRecipientId);
  const isRecipientEnabled =
    NEW_WIZARD_INDIA_ENABLED_FOR_RECIPIENTS.includes(recipientId);
  const { data: flags } = usePeertransferFlags(FF_NEW_INDIA_WIZARD, {
    enabled: isRecipientEnabled,
  });
  const newWizardIndiaFFEnabled = !!flags?.[FF_NEW_INDIA_WIZARD];

  return isRecipientEnabled && newWizardIndiaFFEnabled;
};

export { useNewWizardIndiaEnabled, NEW_WIZARD_INDIA_ENABLED_FOR_RECIPIENTS };
